export default [
  { label: 'Never', value: 'never' },
  { label: 'On date', value: 'on_date' },
  { label: 'After', value: 'after' }
];
